import Browser from '@mindful-web/marko-web/browser';
import Shared from '@transpire-media/package-global/browser';

Shared(Browser);

export default Browser;
